import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { CopyToClipboard } from './CopyToClipboard';

interface Props {
  readonly password: string | null;
  readonly title: string;
  readonly onClose: () => void;
}

// A generated password is shown once, to be sent to its user outside
// e-Socna.
export const GeneratedPasswordDialog = ({
  password,
  title,
  onClose,
}: Readonly<Props>) => (
  <Dialog fullWidth maxWidth="sm" open={!!password}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography
          data-testid="generated-password"
          sx={{ fontFamily: 'monospace', fontSize: '1.4rem' }}
        >
          {password}
        </Typography>
        <CopyToClipboard content={password ?? ''} />
      </Stack>
      <Alert severity="warning" sx={{ mt: 2 }}>
        Ce mot de passe ne sera plus affiché : copiez-le avant de fermer pour le
        communiquer à l&apos;utilisateur. Il devra le changer à sa première
        connexion.
      </Alert>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} size="large" variant="contained">
        Fermer
      </Button>
    </DialogActions>
  </Dialog>
);
